export default __webpack_public_path__ + "static/media/logo.2eeb1290.png";